import { cx } from '@linaria/atomic';
import { XIconSmall } from '../../../icon';
import { IconButton } from '../../icon-button';
import type { FieldHandlers } from '../hooks';
import { clearFieldBtn } from './clear-field-btn.styles';

type Props = Omit<FieldHandlers<HTMLAnchorElement | HTMLButtonElement>, 'onChange'> & {
  onClick: () => void;
  className?: string;
};

export const ClearFieldBtn = ({ className, ...props }: Props) => {
  return (
    <IconButton size='small' label='Clear field' className={cx(clearFieldBtn, className)} {...props}>
      <XIconSmall />
    </IconButton>
  );
};
